export const getEndDate = (): Date => {
  const date = new Date()
  date.setMonth(date.getMonth() + 6)
  return date
}

export const getStartDate = (): Date => {
  const date = new Date()
  date.setDate(date.getDate() - 90)
  return date
}
